import React, { Component } from 'react'
import axios from 'axios';
import {BrowserRouter, NavLink, Route ,Switch} from 'react-router-dom';
import {App} from './App';
import { withRouter } from "react-router";
import {Table} from 'react-bootstrap';
import {Button,ButtonToolbar} from 'react-bootstrap';
import {EditTopicTechMapping} from './EditTopicTechMapping';
import Multiselect from 'multiselect-react-dropdown';
import queryString from 'query-string';
class AdmindefaultTopicTechMapping extends Component {
    constructor (props){
      super(props);
      this.state = {
          TopicList:[],
          DomainList:[],
          TaskList:[],
          techlist:[],
          TechList:[],
          TechListAll:[],
          Topiclist:[],
          options: [],
          techname:"",
          tech:"",
          servicegroup:"",
          addModalShow:false,
          editModalShow:false,
          TaskId:"",
          username:"",
          checked:[],
          defaultcheck:"",
          questionlist:[],
          isLoading: false ,
          checkedItems: new Map()
      } ;
      this.handleChange = this.handleChange.bind(this);              
  }

  componentDidMount() {
    if(document.referrer == ""){
      window.location.replace('https://as-mobilization-stage.accenture.com/Nest-Home.aspx');
    }
    else{
      this.setState({isLoading: true})
    this.handleQueryString();
    document.title ="KTPlanConfigurator";
    }
}
 
  handleChange(event) {
    var isChecked = event.target.checked;
    var item = event.target.value;
    
    this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }));
    let newArray = [...this.state.questionlist, event.target.value];
    if (this.state.questionlist.includes(event.target.value)) {
      newArray = newArray.filter(day => day !== event.target.value);
    }
    this.setState({
      questionlist: newArray
    });
    console.log(this.state.questionlist);
}  
  gettech() {
    fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/Index/TechnologyListDefault/"+this.state.servicegroup).then(response => response.json())
    .then(res=> {            
      this.setState ( { techlist: res } )
        })
        .catch(err => {
          console.log(err);
      }) 
  
  }

  gettopics(flag) {
    if(flag=="Delete")
    {
    alert("Topics deleted successfully");
    }
    console.log(this.state.tech);
    fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopicTech/GetTopicList/"+this.state.tech).then(response => response.json())
    .then(res=> {            
      this.setState ( { Topiclist: res } )
        })
        .catch(err => {
          console.log(err);
      }) 
  
  }

  Delete() {
    fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTopicTech/DeleteTopics/"+this.state.questionlist+"/"+this.state.tech).then(response => response.json())
    .then(res=> { 
        this.gettopics("Delete");
           
          })
          .catch(err => {
            console.log(err);
            alert("Data failed to delete");
        }) 
       
    
  }

  SGChange(e) {
    if(e.target.value != "Select")
  {
  this.state.servicegroup = e.target.value;
  this.gettech();
  }
  }

  techchange(e) {
    this.state.tech = e.target.value;
    this.gettopics("");
  }

  TopicClick() {

    this.props.history.push({
  
      pathname: '/AdminTopics',
      search:"?username="+this.state.username,
    })  
  }
  adminClick(){
  
    this.props.history.push({
  
      pathname: '/',
      
      state: {  username:this.state.username},
      search:"?username="+this.state.username,
  })
  }
  TasksClick() {
  
    this.props.history.push({
  
      pathname: '/AdminTasks',
      search:"?username="+this.state.username,
    })  
  }
  
  TasksHeaderClick() {
  
    this.props.history.push({
  
      pathname: '/AdminTaskHeader',
      search:"?username="+this.state.username,
    })  
  }

  handleQueryString = () => {
    let queries = queryString.parse(window.location.search)
    if(queries.username !=undefined)
    {
      this.state.username = queries.username;
    }
  }
  TechClick() {

    this.props.history.push({
  
      pathname: '/AdminTechnology',
      search:"?username="+this.state.username,
      
    })  
  }
  TopicTechClick() {
  
    this.props.history.push({
  
      pathname: '/AdminTopicTechMapping',
      search:"?username="+this.state.username,
    })  
  }
  
  TopicTechdefaultClick() {
  
    this.props.history.push({
  
      pathname: '/AdmindefaultTopicTechMapping',
      search:"?username="+this.state.username,
    })  
  }

  render() {
  
   
      return (
        this.state.isLoading ? (
        <div class="bg-background" style={{background:'#F2F2F2'}}>
        <div class="row">
            <div class="container-fluid">
            <div class="header-content" style={{marginLeft:17}}>
              <img src="images/Capture.png" style={{paddingBottom:5}} alt="Accenture Technology" class="img-icon" />
              <span class="new-KT-navbar" style={{marginLeft:5}}>KT Plan Configurator</span>
              <button type='button' style={{marginLeft:850,marginTop:5}}  className='btn-new btn-confirm' onClick={() => this.adminClick()}>KT Plan</button>

          </div>
              <div class="demographic-form margin-top15 border-main-div new-KT" style={{height:500,overflow:'auto'}} >
              <div class="ul-financials margin-bottom15">
              <a  style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TechClick()}>Technology</a>
              <a  Text="Header" style={{marginRight:50,color:'black',fontWeight:'bold'}}  ID="lnkTasksHeaders" onClick={() => this.TasksHeaderClick()} >Tasks Header Maintenance</a>
              <a  Text="Tasks" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TasksClick()} ID="lnkTasks" >Tasks Maintenance</a>                             
                <a Text="Topic" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TopicClick()} ID="lnkTopic" >Topic Maintenance</a>
                <a  Text="Topic Technology" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TopicTechClick()} >Topic-Technology Mapping</a>
                <a Text="Topic" class="active" style={{marginRight:50,color:'black',fontWeight:'bold',borderBottom:2,borderBottomColor:'#7500c0',borderBottom:'solid',paddingBottom:5}}  ID="lnkTopic" >Default Technology</a>


            </div>
        <div>
        <div class="col-md-12">
        <div class="col-md-4" >
        <label for=" " class="control-label margin-bottom5  margin-top5" >Service Group *</label>
        <select style={{width:275,height:37}} onChange={(e) => this.SGChange(e)} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance" id="ContentPlaceHolder1_ddlIncludeGovernance" class="aspNetDisabled form-control input-sm   textarea-style watermark">
        <option value="Select">Select</option>
        <option value="AO">AMS</option>
        <option value="IO">IMS</option>
       
        </select>
       
      </div>

            <div class="col-md-4">
            <label for=" " class="control-label margin-bottom5  margin-top5" >{this.state.servicegroup=="AO"?"What is the  technology? *":"What is the IMS Tower? *"} </label>
            <select style={{width:275,height:38,display:'block',disabled:true}} onChange={(e) => this.techchange(e)}  name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance" id='ddlTech' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
            <option>Select</option>
            {
                
                this.state.techlist.map(list =>
                    <option value={list.value} key={list.text} >{list.text}</option>)
            }

            </select>

            </div>
            </div>
            <div class="col-md-12 " >
                      <button type='button'  className='btn-new' onClick={()=>this.Delete()} style={{marginBottom:5}} >Delete</button>
                   
                     
                    </div>

<div class="col-md-12">
<Table className='mt-4' striped bordered hover size='sm'>
<thead style={{background:'#e6dcff'}}>
 <tr>

 <th>Task</th>
 <th>KT Phase</th>
 <th>Topic</th>
 <th>Use Case</th>
 <th>Description</th>
 <th></th>
 </tr>
</thead>
<tbody>
 {
 this.state.Topiclist.map(obj=>
 <tr key={obj.topicsid}>
    
      <td>{obj.Task_Name}</td>
      <td>{obj.KTPhase}</td> 
      <td>{obj.Topic}</td>
      <td>{obj.UseCase}</td>
      <td>{obj.Description}</td>
      <td>
       <input type='checkbox' value={obj.topicsid} onChange={this.handleChange} ></input>
      </td>
 </tr>
 )}
</tbody>
</Table>
</div>
</div> 
</div>
</div>
</div>
</div>)
                  :
                  (<div>Invalid Session, Please login again..</div>)

      )
}
}
export default withRouter(AdmindefaultTopicTechMapping);